import React, { useEffect, useState, useRef } from 'react';

// healthcare providers images
import kpj_img from '../assets/images/new-homepage/healthcare_providers/kpj-healthcare-logo.png';
import sime_img from '../assets/images/new-homepage/healthcare_providers/ramsay-sime-darby-logo.png';
import columbia_img from '../assets/images/new-homepage/healthcare_providers/columbia-asia-logo.png';
import pantai_img from '../assets/images/new-homepage/healthcare_providers/pantai-hospital-logo.png';
import siloam_img from '../assets/images/new-homepage/healthcare_providers/Siloam-hospital-logo.png';
import bumrungrad_img from '../assets/images/new-homepage/healthcare_providers/bumrungrad-thai-logo.png';

const ItemComponent = ({ image }) => {
  return <div className="healthcare-provider-img">
    <img src={image} alt='provider-imgs'/>
  </div>;
};

const Slider = () => {
  const [clickCount, setClickCount] = useState(0);
  const mainWrap = useRef();
  const containerRef = useRef();
  const healthcare_providers = [kpj_img, sime_img, columbia_img, pantai_img, siloam_img, bumrungrad_img]
  const buttonRef = useRef(null);
  const slideshowRef = useRef(null);

  const scrollSllides = (direction) => {
    const width = mainWrap.current?.clientWidth;
    let scrollTo;

    const diff = direction === "next" ? 1 : -1;
    const newValue = (clickCount + diff) % (healthcare_providers.length / 3);
    setClickCount(newValue);
    scrollTo = width * newValue;

    containerRef.current?.scrollTo({
      behavior: "smooth",
      left: scrollTo
    });
  };

  useEffect(() => {
    slideshowRef.current = setInterval(() => {
      buttonRef.current.click();
    }, 5000);
    return () => {
     clearInterval(slideshowRef.current);
    };
  },[])

  return (
    <div>
      <div className="flex-row pt-2 healthcare-provider-items flex-wrap desktop-version">
        {
          healthcare_providers.map((value, index) => (
            <ItemComponent key={index} image={value} />
          ))
        }
      </div>
      <div ref={mainWrap} className="mobile-version">
        <button onClick={() => scrollSllides("prev")} className="btn btn-link prev-btn">
          <i className="fa-solid fa-chevron-left"></i>
        </button>
        <button onClick={() => scrollSllides("next")} ref={buttonRef} className=" btn btn-link next-btn">
          <i className="fa-solid fa-chevron-right"></i>
        </button>
        <div className="slider" ref={containerRef}>
          {healthcare_providers?.map((value, index) => (
            <ItemComponent key={index} image={value} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;